import React from 'react';

const BulkUploadIcon = () => {
  return (
    <svg
      width='44'
      height='44'
      viewBox='0 0 44 44'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        width='44'
        height='44'
        rx='5.33333'
        fill='#3B7CF4'
        fillOpacity='0.1'
      />
      <path
        d='M20.6667 22C20.4899 22 20.3203 22.0702 20.1953 22.1953C20.0702 22.3203 20 22.4899 20 22.6667C20 22.8435 20.0702 23.013 20.1953 23.1381C20.3203 23.2631 20.4899 23.3333 20.6667 23.3333H23.3333C23.5101 23.3333 23.6797 23.2631 23.8047 23.1381C23.9298 23.013 24 22.8435 24 22.6667C24 22.4899 23.9298 22.3203 23.8047 22.1953C23.6797 22.0702 23.5101 22 23.3333 22H20.6667Z'
        fill='#3B7CF4'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.6641 15.3335C16.1336 15.3335 15.6249 15.5442 15.2498 15.9193C14.8748 16.2944 14.6641 16.8031 14.6641 17.3335V26.6668C14.6641 27.1973 14.8748 27.706 15.2498 28.081C15.6249 28.4561 16.1336 28.6668 16.6641 28.6668H27.3307C27.8612 28.6668 28.3699 28.4561 28.7449 28.081C29.12 27.706 29.3307 27.1973 29.3307 26.6668V17.3335C29.3307 16.8031 29.12 16.2944 28.7449 15.9193C28.3699 15.5442 27.8612 15.3335 27.3307 15.3335H16.6641ZM27.3307 16.6668H16.6641C16.4873 16.6668 16.3177 16.7371 16.1927 16.8621C16.0676 16.9871 15.9974 17.1567 15.9974 17.3335V19.3335H27.9974V17.3335C27.9974 17.1567 27.9272 16.9871 27.8021 16.8621C27.6771 16.7371 27.5075 16.6668 27.3307 16.6668ZM15.9974 26.6668V20.6668H27.9974V26.6668C27.9974 26.8436 27.9272 27.0132 27.8021 27.1382C27.6771 27.2633 27.5075 27.3335 27.3307 27.3335H16.6641C16.4873 27.3335 16.3177 27.2633 16.1927 27.1382C16.0676 27.0132 15.9974 26.8436 15.9974 26.6668Z'
        fill='#3B7CF4'
      />
    </svg>
  );
};

export default BulkUploadIcon;
